export default function (mtnUser) {
    return {
        username: mtnUser.Username,
        msisdn: mtnUser.Msisdn,
        status: getStatus(mtnUser.Status),
        subscriptionId: mtnUser.SubscriptionId,
        campaignId: mtnUser.CampaignId,
        activatedAt: mtnUser.DateAdded,
        optInServiceMsgs: mtnUser.OptInServiceMsgs,
        optInContentMsgs: mtnUser.OptInServiceMsgs,
        avatar: mtnUser.Avatar,
        automatedEntries: mtnUser.AutomatedEntries,
        freePlayService: mtnUser.FreeToPlay,
        serviceId: mtnUser.Service,
        externalRef: 12335642,
    }
}

function getStatus(mtnStatus) {
    if (mtnStatus.toLowerCase() === 'active') return 'Active'
    else return 'Pending'
}
